<template>
  <div class="card">
    <header class="header-card columns is-marginless">
      <div class="column pdt-0 pdl-0">
        <p>{{ $t('detailCommande.indexation.title')}}</p>
      </div>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.nomIndice')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ indice }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.dateIndexationReference')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ func.formatDate(commande.dateIndexationReference) }}
              {{ trimestreReference }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.valeurIndexationReference')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ commande.valeurIndexationReference }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.valeurIndexationActuel')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ commande.valeurIndexationActuel }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.dateIndexationActuel')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ func.formatDate(commande.dateIndexationActuel) }}
            </span>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field
            :label="$t('detailCommande.indexation.dateDerniereIndexation')"
            custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <span class="has-text-link has-text-weight-bold">
              {{ func.formatDate(commande.dateDerniereIndexation) }}
              {{ trimestreActuel }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '@/services/general/formatDate';
import { getAll } from '@/api/indiceEtValeur/';
import messageErreur from '@/services/general/messageErreur';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import getItemIndiceValeurs from '@/services/indexation/getItemIndicesValeurs';

export default {
  name: 'IndexationCommandeDetail',
  props: {
    commande: {
      type: Object,
      required: true,
    },
    indice: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      func: {
        formatDate,
      },
      indiceValeurReference: null,
      indiceValeurActuel: null,
    };
  },
  computed: {
    trimestreReference() {
      const trimestre = this.indiceValeurReference?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
    trimestreActuel() {
      const trimestre = this.indiceValeurActuel?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
  },
  methods: {
    async getIndiceEtValeur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const { items } = (await getAll({ limit: NO_PAGINATION })).data.result;
        const result = getItemIndiceValeurs(items, this.commande);
        this.indiceValeurReference = result?.indiceValeurReference;
        this.indiceValeurActuel = result?.indiceValeurActuel;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    await this.getIndiceEtValeur();
  },
};
</script>
